// Lets overhaul this workerDash component. 
//We will use redux to manage state and fetch job sites. 
//we will also use reduc to manage worker location and handle logout functionality.
// When the redux state for location is set, we will fetch the jobsites and sort them by distance from the worker's location. 



import { useSelector, useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import { useState, useEffect } from 'react';
import { FaCalendarAlt, FaSignOutAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import {getEmployerJobsites, resetEmployerJobsites} from '../../features/workerJobsites/employerJobsitesSlice';
import JobsiteCardContainer from '../../components/workerUser_Components/JobsiteCardContainer';
import { setWorkerLocation } from '../../features/workerAuth/workerAuthSlice';
import Spinner from '../../components/Spinner';
import {logoutWorker, resetWorkerUser} from '../../features/workerAuth/workerAuthSlice'
import { Navigate } from 'react-router-dom';

// Function to calculate distance between two coordinates
const calculateDistance = (lat1, lon1, lat2, lon2) => {
  const toRad = (value) => (value * Math.PI) / 180;
  const R = 6371; // Radius of the Earth in km
  const dLat = toRad(lat2 - lat1);
  const dLon = toRad(lon2 - lon1);
  const a =
    Math.sin(dLat / 2) * Math.sin(dLon / 2) +
    Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
    Math.sin(dLon / 2) * Math.sin(dLon / 2);
  const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
  return R * c; // Distance in km
};

function WorkerDash() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  
  //handle logout click
  const handleLogoutClick = () => {
    dispatch(resetEmployerJobsites()) //resets the jobsites state to initial state
    dispatch(logoutWorker())     //removes the workerUser data from local storage
    dispatch(resetWorkerUser())  //resents the redux state to initial state for slice workerAuth
    
    navigate("/workerLogin")
};
  

  const [sortedJobSites, setSortedJobSites] = useState([]);



  // Redux store states
  const workerUser = useSelector((state) => state.workerAuth.workerUser);
  const {jobsites, isLoading, isError, message} = useSelector((state) => state.employerJobsites);
  const profilePictureUrl = workerUser?.profilePictureUrl;
  const workerLocation = useSelector((state) => state.workerAuth.workerLocation);  //has longitude and latitude.
  // Handle navigation to calendar
  const handleHistoryClick = () => {
    navigate(`/calendar`);
  };

  // Check onboarding status
  useEffect(() => {
  if (workerUser?.onboarded === false) {
    toast.info('Complete your onboarding');
    navigate('/workerOnboarding');
    }
  }, [workerUser, navigate]);


  // Handle geolocation errors
  // This function will handle geolocation errors and display appropriate messages
  // It will be used in the useEffect hook to handle errors when fetching the worker's location.
  // It will also be used in the handleRetryLocation function to retry getting the location
  // without reloading the page.
  // It will also be used in the getLocation function to handle errors when getting the location
  // without reloading the page.
  // It will also be used in the handleGeoError function to handle errors when getting the
  // location without reloading the page.
  // It will also be used in the handleRetryLocation function to retry getting the location
  // without reloading the page.
  // It will also be used in the getLocation function to handle errors when getting the location
  // without reloading the page.
  // It will also be used in the handleGeoError function to handle errors when getting the
  // location without reloading the page.
  // It will also be used in the handleRetryLocation function to retry getting the location
  // without reloading the page.  
  const handleGeoError = (error) => {
  switch (error.code) {
    case error.PERMISSION_DENIED:
      toast.error('Location permission denied. Please allow access in your browser or device settings.');
      break;
    case error.POSITION_UNAVAILABLE:
      toast.error('Location information is unavailable.');
      break;
    case error.TIMEOUT:
      toast.error('Location request timed out. Try again.');
      break;
    default:
      toast.error('An unknown error occurred while fetching location.');
  }
};

  // Fetch job sites and worker location
  useEffect(() => {
    // If workerUser is not defined or not onboarded, do not proceed 
    if (!workerUser || workerUser.onboarded === false) {
      return;
    }

    // Get worker's current location
    const getLocation = () => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => {
            const location = {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude,
            };
            dispatch(setWorkerLocation(location));
          },
           handleGeoError
        );
      } else {
       
        toast.error('Enanble location services in your browser settings');
      }
    };

    getLocation();

    // Fetch jobsites
    dispatch(getEmployerJobsites());
  }, [workerUser, dispatch]);

  // Add a handler to retry getting location without reloading
  const handleRetryLocation = () => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
        (position) => {
          const location = {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          };
          dispatch(setWorkerLocation(location));
        },
        (error) => {
          console.log(error);
          toast.error('Location access denied. Please enable location services in your browser settings.');
        }
      );
    } else {
      toast.error('Geolocation is not supported by this browser.');
    }
  };

  // Sort job sites by distance
  useEffect(() => {
    if (workerLocation && jobsites  && jobsites.length > 0) {
      const sorted = [...jobsites]
        .map((jobsite) => ({
          ...jobsite,
          distanceAway: calculateDistance(
            workerLocation.latitude,
            workerLocation.longitude,
            jobsite.latitude,
            jobsite.longitude
          ),
        }))
        .sort((a, b) => a.distanceAway - b.distanceAway);

      setSortedJobSites(sorted);
    }else {
      setSortedJobSites([]); // Clear job sites if no location or jobsites
    }
  }, [workerLocation, jobsites]);

  
  if (!workerUser) {
   return <Navigate to="/workerLogin" />;
  }
  // Render loading spinner
  
  if (isLoading) {
    return <Spinner />;
  }

  // Render error message
  if (isError) {
    return <div className="p-4 text-center text-red-500">{message}</div>;
  }

  return (
    <div className="flex flex-col lg:flex-row min-h-screen"> {/* Stretch to viewport height */}
      {/* Sidebar for large screens only */}
      <div className="hidden md:flex md:w-1/4 p-2 bg-slate-100 rounded-lg flex-col items-center">
        <img
          src={profilePictureUrl}
          alt={`${workerUser.workerName} ${workerUser.workerLastName}`}
          className="w-24 h-24 rounded-full mx-auto"
        />
        <p className="text-xl mt-2 text-center">
          <span className="text-gray-700 text-3xl">
            <p>
              {workerUser.workerName} {workerUser.workerLastName}
            </p>
          </span>
        </p>
        <button
          className="mt-4 p-2 font-sans text-lg flex items-center hover:bg-slate-300 hover:text-black"
          onClick={handleHistoryClick}
        >
          <FaCalendarAlt className="mr-2" />
          Work History
        </button>
        {/* Log Out button removed from sidebar for md+ screens */}
      </div>
      {/* Main content area */}
      <div className="flex-1 flex flex-col">
        {/* Worker info for small screens */}
        <div
          className="
            flex md:hidden w-full px-4 py-4 bg-white shadow mb-2
            flex-col items-center justify-center
            flex-grow
            min-h-[30vh] max-h-[45vh]
          "
          style={{
            minHeight: 'clamp(160px, 30vh, 320px)',
            maxHeight: 'clamp(220px, 45vh, 400px)',
          }}
        >
          <div className="flex flex-col items-center flex-1 justify-center w-full">
            <img
              src={profilePictureUrl}
              alt={`${workerUser.workerName} ${workerUser.workerLastName}`}
              className="
                rounded-full
                transition-all
                mb-2
              "
              style={{
                width: 'clamp(112px, 32vw, 220px)',
                height: 'clamp(112px, 32vw, 220px)',
                minWidth: '112px',
                minHeight: '112px',
                maxWidth: '220px',
                maxHeight: '220px',
                objectFit: 'cover',
              }}
            />
            <span
              className="font-semibold mt-2 text-center"
              style={{
                fontSize: 'clamp(1.5rem, 2.5vw, 2rem)',
              }}
            >
              {workerUser.workerName} {workerUser.workerLastName}
            </span>
          </div>
          <div className="flex flex-col justify-center items-stretch w-full mt-4 space-y-2">
            <button
              className="p-2 font-sans flex items-center hover:bg-slate-200 rounded w-full text-base bg-tan"
              onClick={handleHistoryClick}
              style={{
                fontSize: 'clamp(0.95rem, 2vw, 1.15rem)',
              }}
            >
              <FaCalendarAlt className="mr-1" />
              Work History
            </button>
            {/* Log Out button only on small screens */}
            <button
              className="p-2 font-sans flex items-center bg-red-500 text-white rounded w-full text-base"
              onClick={handleLogoutClick}
              style={{
                fontSize: 'clamp(0.95rem, 2vw, 1.15rem)',
              }}
            >
              <FaSignOutAlt className="mr-1" />
              Log Out
            </button>
          </div>
        </div>

        {/* Job sites container */}
        <div className="container mx-auto px-0 lg:px-0 lg:w-full lg:h-screen lg:overflow-y-auto bg-gray-100 flex-1 flex flex-col">
          {workerLocation === null ? (
            <div className="p-4 text-center">
              <h2 className="text-2xl text-gray-500 mb-4">
                Location is required to show nearby jobsites.<br />
                Turn On location services in your browser settings, then try again.
              </h2>
              <button
                className="px-4 py-2 bg-blue-600 text-white rounded hover:bg-blue-700"
                onClick={handleRetryLocation}
              >
                Try Again
              </button>
              
            </div>
          ) : sortedJobSites.length !== 0 ? (
            <div
              className="
                flex flex-col gap-4 py-6 px-0
                overflow-y-auto items-center
                max-h-[60vh] lg:max-h-[70vh]
                w-full
                md:grid md:grid-cols-2 lg:grid-cols-3 md:gap-8 md:overflow-y-auto
                scrollbar-thumb-slate-300 scrollbar-track-transparent
              "
            >
              {sortedJobSites.map((jobSite, idx) => (
                <div
                  key={jobSite.id}
                  className={`
                    w-full max-w-md mx-0
                    transition-transform duration-300
                    p-4 bg-white rounded-lg
                    mb-4 last:mb-0
                    ${idx === 0
                      ? 'z-10 md:z-0'
                      : ''
                    }
                  `}
                  style={{
                    transition: 'transform 0.3s cubic-bezier(0.4,0,0.2,1)',
                  }}
                >
                  <JobsiteCardContainer jobSite={jobSite} />
                </div>
              ))}
            </div>
          ) : (
            <div className="p-4 text-center">
              <h2 className="text-2xl text-gray-500">
                Employer doesn't have any jobsites
              </h2>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default WorkerDash;